import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

import { untilDestroyed } from '@app/core';
import { DocumentInput, User, WhatsappTemplateEnum } from '@app/models';
import { AppService, UserService, WhitelabelService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-document-configs-whatsapp',
  templateUrl: './document-configs-whatsapp.component.html',
  styleUrls: ['./document-configs-whatsapp.component.scss'],
  standalone: false
})
export class DocumentConfigsWhatsappComponent implements OnInit, OnChanges, OnDestroy {
  @Input() document: DocumentInput;
  @Output() documentChange = new EventEmitter<DocumentInput>();
  selectedLang: string;
  currentUser: User;

  readonly WhatsappTemplateEnum = WhatsappTemplateEnum;

  constructor(public appService: AppService, public translateService: TranslateService, public whitelabelService: WhitelabelService, private userService: UserService) {}

  ngOnInit() {
    this.document.whatsapp_template = this.document.whatsapp_template || this.WhatsappTemplateEnum.Casual;
    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({ next: user => (this.currentUser = user) });
  }

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.document.currentValue) {
      this.selectedLang = (this.document.locale?.language || '').replace('-', '');
    }
  }
}
